"use client"

import {
  ProductListingActiveFilters,
} from "@/components/organisms";
import { ProductGrid } from "@/components/organisms/ProductGrid/ProductGrid";
import { MeilisearchProductSidebar } from "@/components/organisms/ProductSidebar/MeilisearchProductSidebar";
import { HttpTypes } from "@medusajs/types";
import { useTranslate } from "@tolgee/react";
const PAGE_SIZE = 36;

export const MeilisearchProductsList = ({
  products,
  meiliProducts,
  count,
  locale
}: {
  products: HttpTypes.StoreProduct[],
  meiliProducts: HttpTypes.StoreProduct[]
  count: number
  locale: string
}) => {
  const { t } = useTranslate()
  return (
    <>
      <div className="flex justify-between w-full items-center">
        <div className="my-4 label-md">{`${count} ${t("algolia_products_listing.listings")}`}</div>
      </div>
      <div className="hidden md:block">
        <ProductListingActiveFilters />
      </div>
      <div className="md:flex gap-4">
        <MeilisearchProductSidebar />
        <div className="w-full">
          {!products.length ? (
            <div className="text-center w-full my-10">
              <h2 className="uppercase text-primary heading-lg">{t("algolia_products_listing.no_results")}</h2>
              <p className="mt-4 text-lg">
                {t("algolia_products_listing.no_results_description")}
              </p>
            </div>
          ) : (
            <ProductGrid
              products={products}
              hits={meiliProducts}
              count={count}
              locale={locale}
              pageSize={PAGE_SIZE}
            />
          )}
        </div>
      </div>
    </>
  )
}